(function () {
  'use strict';

  if (window.__drmRecipeBinderGiftLoaded) return;

  var CFG = window.drmRecipeBinderGift;
  if (!CFG || CFG.enabled === false) return;
  window.__drmRecipeBinderGiftInit = true;

  var VARIANT_IDS = new Set();
  var CONFIG_VARIANTS = [];
  (CFG.variants || []).forEach(function (item) {
    var id = parseInt(item && item.id, 10);
    if (!isFinite(id)) return;
    VARIANT_IDS.add(id);
    CONFIG_VARIANTS.push(item);
  });
  var hasVariants = VARIANT_IDS.size > 0;

  var GIFT_HANDLE = CFG.giftHandle ? String(CFG.giftHandle) : '';
  var PAID_HANDLE = CFG.paidHandle ? String(CFG.paidHandle) : '';
  var GIFT_PRODUCT_ID = parseInt(CFG.giftProductId, 10) || 0;
  var PAID_PRODUCT_ID = parseInt(CFG.paidProductId, 10) || 0;

  var DEFAULT_VARIANT_ID = parseInt(CFG.defaultVariantId, 10);
  if (!isFinite(DEFAULT_VARIANT_ID)) DEFAULT_VARIANT_ID = 0;
  if (!VARIANT_IDS.has(DEFAULT_VARIANT_ID) && CONFIG_VARIANTS.length) {
    DEFAULT_VARIANT_ID = parseInt(CONFIG_VARIANTS[0].id, 10);
  }

  

  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var PAID_URL = CFG.paidUrl ? String(CFG.paidUrl) : (PAID_HANDLE ? ROOT + 'products/' + PAID_HANDLE : '');

  function currentProductHandle() {
    var match = (window.location.pathname || '').match(/\/products\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : '';
  }

  function maybeRedirectGiftPage() {
    if (!GIFT_HANDLE || !PAID_URL) return;
    if (currentProductHandle() === GIFT_HANDLE) window.location.replace(PAID_URL);
  }

  function rewriteGiftLinks() {
    if (!GIFT_HANDLE || !PAID_URL) return;
    document.querySelectorAll('a[href*="/products/' + GIFT_HANDLE + '"]').forEach(function (link) {
      link.setAttribute('href', PAID_URL);
    });
  }

  maybeRedirectGiftPage();
  function ingestGiftProduct(giftProduct) {
    window.__drmRecipeBinderGiftFetchGiftFound = !!giftProduct;
    window.__drmRecipeBinderGiftFetchGiftVariantsOk = !!(giftProduct && Array.isArray(giftProduct.variants));
    if (!giftProduct || !Array.isArray(giftProduct.variants)) return false;
    if (!GIFT_PRODUCT_ID && giftProduct.id) GIFT_PRODUCT_ID = parseInt(giftProduct.id, 10) || GIFT_PRODUCT_ID;
    giftProduct.variants.forEach(function (v) {
      var id = parseInt(v && v.id, 10);
      if (!isFinite(id)) return;
      VARIANT_IDS.add(id);
      CONFIG_VARIANTS.push({ id: id, available: v.available !== false });
    });
    window.__drmRecipeBinderGiftParsedCount = VARIANT_IDS.size;
    return VARIANT_IDS.size > 0;
  }

  function loadGiftVariantsFromProductsJson() {
    if (hasVariants || !GIFT_HANDLE) return Promise.resolve(true);
    return fetch(ROOT + 'products/' + encodeURIComponent(GIFT_HANDLE) + '.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    })
      .then(function (res) {
        window.__drmRecipeBinderGiftFetchProductsOk = !!res.ok;
        if (!res.ok) return null;
        return res.json();
      })
      .then(function (data) {
        return ingestGiftProduct(data);
      })
      .catch(function () {
        window.__drmRecipeBinderGiftFetchError = true;
        return false;
      });
  }

  var readyPromise = loadGiftVariantsFromProductsJson().then(function (ok) {
    if (!ok) return false;
    if (!isFinite(DEFAULT_VARIANT_ID) || !VARIANT_IDS.has(DEFAULT_VARIANT_ID)) {
      if (CONFIG_VARIANTS.length) DEFAULT_VARIANT_ID = parseInt(CONFIG_VARIANTS[0].id, 10);
    }
    window.__drmRecipeBinderGiftReadyOk = true;
    window.__drmRecipeBinderGiftLoaded = true;
    scheduleSync(300);
    return true;
  });

  var GIFT_QTY = 1;
  var SYNC_DEBOUNCE = 400;
  var SELF_QUIET_MS = 1200;
  var MUTATION_BUDGET = 8;
  var MUTATION_WINDOW = 30000;

  var syncTimer = null;
  var syncing = false;
  var quietUntil = 0;
  var lastSig = '';
  var mutationLog = [];

  function variantIdOf(item) {
    if (!item) return 0;
    var raw = item.variant_id != null ? item.variant_id : item.id;
    var n = parseInt(raw, 10);
    return isFinite(n) ? n : 0;
  }

  function productIdOf(item) {
    if (!item) return 0;
    var raw = item.product_id != null ? item.product_id : item.productId;
    var n = parseInt(raw, 10);
    return isFinite(n) ? n : 0;
  }

  function handleOf(item) {
    if (!item) return '';
    if (item.handle) return String(item.handle);
    var url = String(item.url || '');
    var match = url.match(/\/products\/([^/?#]+)/);
    return match ? match[1] : '';
  }

  function keyOf(item) {
    return item && item.key != null ? String(item.key) : '';
  }

  function qtyOf(item) {
    var n = parseInt(item && item.quantity, 10);
    return isFinite(n) && n > 0 ? n : 0;
  }

  function isGift(item) {
    if (!item) return false;
    if (GIFT_HANDLE && handleOf(item) === GIFT_HANDLE) return true;
    if (GIFT_PRODUCT_ID && productIdOf(item) === GIFT_PRODUCT_ID) return true;
    if (VARIANT_IDS.has(variantIdOf(item))) return true;
    return false;
  }

  function isPaidBinder(item) {
    if (!item) return false;
    if (PAID_HANDLE && handleOf(item) === PAID_HANDLE) return true;
    if (PAID_PRODUCT_ID && productIdOf(item) === PAID_PRODUCT_ID) return true;
    return false;
  }

  function isTriggerItem(item) {
    if (!item || qtyOf(item) < 1) return false;
    if (isGift(item)) return false;
    if (isPaidBinder(item)) return false;
    return true;
  }

  function qualifies(cart) {
    var items = cart && cart.items ? cart.items : [];
    for (var i = 0; i < items.length; i++) {
      if (isTriggerItem(items[i])) return true;
    }
    return false;
  }

  function cartSig(cart) {
    return (cart && cart.items ? cart.items : [])
      .map(function (item) {
        return variantIdOf(item) + 'x' + qtyOf(item);
      })
      .sort()
      .join('|');
  }

  function giftPlan(cart) {
    var items = cart && cart.items ? cart.items : [];
    var gifts = items.filter(isGift);
    var updates = {};

    if (!qualifies(cart)) {
      gifts.forEach(function (item) {
        var k = keyOf(item);
        if (k) updates[k] = 0;
      });
      return { updates: updates, addId: null };
    }

    if (!gifts.length) return { updates: {}, addId: DEFAULT_VARIANT_ID };

    var keep = gifts[0];
    gifts.forEach(function (item) {
      var k = keyOf(item);
      if (!k) return;
      if (item === keep) {
        if (qtyOf(item) !== GIFT_QTY) updates[k] = GIFT_QTY;
      } else {
        updates[k] = 0;
      }
    });

    return { updates: updates, addId: null };
  }

  function getCart() {
    return fetch(ROOT + 'cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(function (res) {
      if (!res.ok) throw new Error('cart');
      return res.json();
    });
  }

  function budgetOk() {
    var now = Date.now();
    mutationLog = mutationLog.filter(function (t) {
      return now - t < MUTATION_WINDOW;
    });
    if (mutationLog.length >= MUTATION_BUDGET) return false;
    mutationLog.push(now);
    return true;
  }

  function sectionIds() {
    var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    if (cart && typeof cart.getSectionsToRender === 'function') {
      return cart.getSectionsToRender().map(function (section) {
        return section.id;
      });
    }
    return ['cart-drawer', 'cart-icon-bubble'];
  }

  function applyUpdates(updates) {
    var keys = Object.keys(updates || {});
    if (!keys.length) return Promise.resolve(null);
    if (!budgetOk()) return Promise.resolve(null);

    var body = {
      updates: updates,
      sections: sectionIds(),
      sections_url: window.location.pathname
    };

    return fetch(ROOT + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(body)
    })
      .then(function (res) {
        if (!res.ok) return null;
        return res.json();
      })
      .catch(function () {
        return null;
      });
  }

  function paintCart(parsedState) {
    if (!parsedState || !parsedState.sections) return;

    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.renderContents === 'function') {
      quietUntil = Date.now() + SELF_QUIET_MS;
      drawer.classList.toggle('is-empty', parsedState.item_count === 0);
      drawer.getSectionsToRender().forEach(function (section) {
        var sectionElement = section.selector
          ? document.querySelector(section.selector)
          : document.getElementById(section.id);
        if (!sectionElement || !parsedState.sections[section.id]) return;
        var html = parsedState.sections[section.id];
        var selector = section.selector || '.shopify-section';
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var el = doc.querySelector(selector);
        if (el) sectionElement.innerHTML = el.innerHTML;
      });
      var overlay = drawer.querySelector('#CartDrawer-Overlay');
      if (overlay) overlay.addEventListener('click', drawer.close.bind(drawer));
      rewriteGiftLinks();
      return;
    }

    var cartItems = document.querySelector('cart-items');
    if (cartItems && typeof cartItems.getSectionsToRender === 'function' && parsedState.sections) {
      quietUntil = Date.now() + SELF_QUIET_MS;
      cartItems.classList.toggle('is-empty', parsedState.item_count === 0);
      cartItems.getSectionsToRender().forEach(function (section) {
        var root = document.getElementById(section.id);
        if (!root) return;
        var target = root.querySelector(section.selector) || root;
        var html = parsedState.sections[section.section];
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var el = doc.querySelector(section.selector) || doc.querySelector('.shopify-section');
        if (el) target.innerHTML = el.innerHTML;
      });
      rewriteGiftLinks();
    }
  }

  function commit(cart) {
    lastSig = cartSig(cart);
  }

  function sync() {
    if (syncing || Date.now() < quietUntil) return;
    syncing = true;

    getCart()
      .then(function (cart) {
        var sig = cartSig(cart);
        if (sig === lastSig) return null;

        var plan = giftPlan(cart);

        if (Object.keys(plan.updates).length) return applyUpdates(plan.updates);
        if (plan.addId) {
          var one = {};
          one[String(plan.addId)] = GIFT_QTY;
          return applyUpdates(one);
        }

        lastSig = sig;
        return null;
      })
      .then(function (next) {
        if (next) {
          commit(next);
          paintCart(next);
        }
      })
      .catch(function () {})
      .then(function () {
        syncing = false;
      });
  }

  function scheduleSync(delay) {
    if (syncTimer) clearTimeout(syncTimer);
    syncTimer = setTimeout(sync, typeof delay === 'number' ? delay : SYNC_DEBOUNCE);
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
      scheduleSync(SYNC_DEBOUNCE);
    });
  }

  document.addEventListener('cart:refresh', function () {
    scheduleSync(SYNC_DEBOUNCE);
  });

  rewriteGiftLinks();
  scheduleSync(300);
})();
